import React, { useCallback, useEffect, useState } from 'react';
import './../Form.scss';
import './PedidosForm.scss';
import { useHistory, useParams } from 'react-router';
import service from '../../../services/pedidos';
import serviceCatalogos from '../../../services/catalogos';
import serviceUsuarios from '../../../services/usuarios';
import serviceCampanhas from '../../../services/campanhas';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { hasText, isDate, maskDate } from '../../../utils/utils';
import { actions as actionsSite } from '../../../redux/actions/site';
import { useDispatch, useSelector } from 'react-redux';
import { datetime2Front } from '../../../utils/converts';
import { currencyToFloat, formatCurrency } from '../../../utils/Money';
import CheckBox from '../form/generics/CheckBox';
import { getSituacao } from './Pedidos';

const PedidosFormProcess = props => {

    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth.profile);
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const params = useParams();

    const [usuarios, setUsuarios] = useState([]);
    const [catalogos, setCatalogos] = useState([]);
    const [pedido, setPedido] = useState({});
    const [itemPedidos, setItemPedidos] = useState([]);
    const [campanhas, setCampanhas] = useState([]);
    const [datasVencimento, setDatasVencimento] = useState([{ data: '' }, { data: '' }, { data: '' }, { data: '' }, { data: '' }, { data: '' }]);


    const { register, handleSubmit, setValue, errors, getValues, setError, clearErrors } = useForm();

    const rota = props.compra ? "pedidos-compra" : "pedidos-venda";

    const montaRecebimento = (campanha, valor) => {
        const usuario = pedido.usuario;
        const campanhaId = campanhas.find(c=>c.codigo===campanha)._id;
        const catalogoCodigo = catalogos.find(c=>c._id===pedido.catalogo).codigo;
        
        const recebimento = {
            usuario,
            campanha: campanhaId,
            valor,
            pedido: pedido._id,
            catalogoCodigo
        }

        return recebimento;
    }

    const onSubmit = data => {
        if (props.compra) {
            data['usuario'] = profile._id;
            data['tipo'] = 'Compra';
        } else {
            data['tipo'] = 'Venda';
        }
        data['itemPedidos'] = itemPedidos;
        data['semMinimo'] = pedido.semMinimo;
        let erros = [];
        if (params.id) {
            const vencimentos = [];
            if (isParcelado()) {
                if (isParceladoCampanha()) {
                    let x = 0;
                    for (let campanha of pedido.campanhasPagamento) {
                        let valor = currencyToFloat(data['valorParcela']);
                        valor += x === 0 ? currencyToFloat(data['valorFrete']) : 0;
                        const recebimento = montaRecebimento(campanha, valor);
                        vencimentos.push({
                            data: null,
                            campanha,
                            dataPagamento: null,
                            valor: (valor).toFixed(2),
                            observacao: '',
                            recebimento
                        });
                        x++;
                    }
                } else if (isParceladoCartao()) {
                    vencimentos.push({
                        data: null,
                        campanha: null,
                        dataPagamento: null,
                        valor: (currencyToFloat(data['valorParcela']) * parseInt(data['numeroParcelas']) + currencyToFloat(data['valorFrete'])).toFixed(2),
                        observacao: ''
                    });
                } else if (isParceladoBoletoDinheiro()) {
                    let x = 0;
                    for (let obj of datasVencimento) {
                        if (obj.data !== '' && isDate(obj.data)) {
                            let valor = currencyToFloat(data['valorParcela']);
                            valor += x === 0 ? currencyToFloat(data['valorFrete']) : 0;
                            vencimentos.push({
                                data: obj.data,
                                campanha: null,
                                dataPagamento: null,
                                valor: (valor).toFixed(2),
                                observacao: ''
                            });
                            x++;
                        }
                    }
                }
                if(vencimentos.length === 0){
                    erros.push('vencimentos');
                    setError('vencimentos', true);
                } else {
                    erros = [];
                    
                }
            } else {
                vencimentos.push({
                    data: null,
                    campanha: null,
                    dataPagamento: null,
                    valor: (currencyToFloat(getTotalValorLiquido()) + currencyToFloat(data['valorFrete'])).toFixed(2),
                    observacao: ''
                });
            }
            data['vencimentos'] = vencimentos;
            if(erros.length === 0){
                processarPedido(data);
            }
        }
    };

    const carregarPedido = useCallback(async (id) => {
        const pedidoInicial = await service.getById(id);
        setPedido(pedidoInicial);
        setItemPedidos(pedidoInicial.items);
        setLoading(false);
    }, []);

    const getYearMonth = date => {
        const yearMonth = parseInt(date.getFullYear().toString() + (date.getMonth()+1).toString().padStart(2,'0'));
        return yearMonth;
    }
    const filtraCampanhas = rows => {
        const now = new Date();
        now.setMonth(now.getMonth()-4)
        const yearMonthMin = getYearMonth(new Date(now));
        // console.log(yearMonthMin);
        // for(const row of rows) {
        //     console.log(getYearMonth(new Date(row.dataInicio)))
        // }
        const filterRows = rows.filter( (e) => {
            const ym = getYearMonth(new Date(e.dataInicio));
            if(ym >= yearMonthMin){
                return e;
            }
            return false;
        });
        return filterRows;
    }


    useEffect(() => {
        const run = async () => {
            const _catalogos = serviceCatalogos.get(`?catalogo=NULL&sort=nome&active=true`);

            const _usuarios = serviceUsuarios.get(`?active=true&sort=nome`);
            const _campanhas = serviceCampanhas.get(`?active=true&sort=dataInicio`);
            const [_resCatalogos, _resUsuarios, _resCampanhas] = await Promise.all([_catalogos, _usuarios, _campanhas]);

            setCatalogos(_resCatalogos.rows);
            setUsuarios(_resUsuarios.rows);
            setCampanhas(filtraCampanhas(_resCampanhas.rows));
            if (params.id) {
                carregarPedido(params.id);
            } else {
                setLoading(false);
            }
        }
        run();
    }, [carregarPedido, params.id]);

    const processarPedido = async (data) => {
        dispatch(actionsSite.setLoadingMsg("Processando pedido..."));
        const res = await service.process(data, pedido._id);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
            if (!res.erro) {
                history.push('/painel/' + rota);
            }
        }, 3000);
    }

    const getCatalogo = id => {
        const obj = catalogos.find(e => e._id === id);
        return obj;
    }

    const getUsuario = id => {
        const obj = usuarios.find(e => e._id === id);
        return obj;
    }

    const changePagamento = e => {
        if (params.id && props.compra) {
            return;
        }

        const _pedido = { ...pedido };
        _pedido.tipoPagamento = e.target.value;
        setPedido(_pedido);
    }

    const optionTiposPagamento = () => {
        const op = [
            { _id: "PIX", label: "PIX" },
            { _id: "Débito", label: "Débito" },
            { _id: "Crédito", label: "Crédito" },

            { _id: "Crédito Parcelado", label: "Crédito Parcelado" },
            { _id: "A Prazo - Dinheiro", label: "A Prazo - Dinheiro" },
            { _id: "A Prazo - Boleto", label: "A Prazo - Boleto" },
            { _id: "A Prazo - Campanha", label: "A Prazo - Campanha" },

        ];
        op.unshift({ _id: "", label: "Selecione um Pagamento" });
        return op.map((o, i) => {
            return <option key={i} value={o._id}>{o.label}</option>;
        });
    }

    const getTotalValorBruto = () => {
        let valor = 0;
        itemPedidos.map((a) => valor += (a.valor) * a.quantidade);
        return formatCurrency(valor);
    }

    const getTotalValorLiquido = () => {
        let valor = 0;
        itemPedidos.map((a) => valor += (a.valor - (a.valor * a.desconto / 100)) * a.quantidade);
        return formatCurrency(valor);
    }

    const getTotalValorLiquidoParcelas = () => {
        const valor = currencyToFloat(getTotalValorLiquido());
        const tarifaParcela = currencyToFloat(getValues('tarifaParcela')) || 0;
        const numeroParcelas = parseInt(getValues('numeroParcelas') || 1);
        const valorParcela = ((valor / numeroParcelas) + tarifaParcela).toFixed(2);
        setValue('valorParcela', formatCurrency(valorParcela))
        return formatCurrency(valorParcela);
    }

    const getTotalValorDesconto = () => {
        let valor = 0;
        itemPedidos.map((a) => valor += ((a.valor * a.desconto / 100)) * a.quantidade);
        return formatCurrency(valor);
    }

    const getTotalPontos = () => {
        let valor = 0;
        itemPedidos.map((a) => valor += (a.produto.pontos * a.quantidade));
        return formatCurrency(valor);
    }

    const renderFormItensPedidosVenda = () => {
        return (
            <table cellPadding="0" cellSpacing="0" className="itensPedido">
                <thead>
                    <tr>
                        <th width="100">Código</th>
                        <th width="50">Qtd.</th>
                        <th width="80">Tamanho</th>
                        <th>Descrição</th>
                        <th width="100">Valor Unit.</th>
                        <th width="100">Valor Bruto</th>
                        <th width="100">Desc. %</th>
                        <th width="100">Desc. R$</th>
                        <th width="100">Valor Líq.</th>
                        <th width="100">Pontos</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        itemPedidos.map((e, index) => {
                            return (
                                <tr key={index}>
                                    <td>{e.produto.codigo}</td>
                                    <td>{e.quantidade}</td>
                                    <td>{e.tamanho}</td>
                                    <td>{e.produto.nome}</td>
                                    <td>
                                        <input name={`valor${index}`} id={`valor${index}`} type="text"
                                            className={"hasText"}
                                            onKeyUp={(e) => hasText(e)} ref={register()}
                                            value={formatCurrency(e.valor)}
                                            onChange={(event) => {
                                                changeValueMoney(event.target.value, { index, campo: 'valor' });
                                                changeValueField(e, 'valor', currencyToFloat(event.target.value), resetItemPedidos);
                                            }}
                                        />
                                    </td>
                                    <td>{formatCurrency(e.valor * e.quantidade)}</td>
                                    <td>
                                        <input name={`desconto${index}`} id={`desconto${index}`} type="text"
                                            className={"hasText"}
                                            onKeyUp={(e) => hasText(e)} ref={register()}
                                            value={formatCurrency(e.desconto)}
                                            maxLength={5}
                                            onChange={(event) => {
                                                changeValueMoney(event.target.value, { index, campo: 'desconto' });
                                                changeValueField(e, 'desconto', currencyToFloat(event.target.value), resetItemPedidos);
                                            }}
                                        />
                                    </td>
                                    <td>{formatCurrency((e.valor * e.desconto / 100) * e.quantidade)}</td>
                                    <td>{formatCurrency((e.valor - (e.valor * e.desconto / 100)) * e.quantidade)}</td>
                                    <td>{formatCurrency(e.produto.pontos * e.quantidade)}</td>
                                </tr>
                            );
                        })
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <th colSpan={5} align="right" style={{ paddingRight: 30 }}>TOTAL</th>
                        <th align="left">{getTotalValorBruto()}</th>
                        <th align="left"></th>
                        <th align="left">{getTotalValorDesconto()}</th>
                        <th align="left">{getTotalValorLiquido()}</th>
                        <th align="left">{getTotalPontos()}</th>
                    </tr>
                </tfoot>
            </table>
        );
    }

    const changeValueMoney = (value, args) => {
        const campo = args.campo + args.index;
        const newValue = formatCurrency(value);
        setValue(campo, newValue);
        document.querySelector("#" + args.campo + args.index).classList.add('hasText');
    }

    const addBreak = () => {
        return <div className="break"></div>;
    }

    const resetItemPedidos = () => {
        const _itemPedidos = [...itemPedidos];
        setItemPedidos(_itemPedidos);
    }

    const changeValueField = (obj, field, value, cb = null) => {
        obj[field] = value;
        if (cb) {
            cb();
        }
    }

    const isParcelado = () => {
        if (pedido.tipoPagamento) {
            return (pedido.tipoPagamento.indexOf("Prazo") !== -1 || pedido.tipoPagamento.indexOf("Parcelado") !== -1);
        }
        return false;
    }

    const isParceladoCampanha = () => {
        if (pedido.tipoPagamento) {
            return (pedido.tipoPagamento.indexOf("Campanha") !== -1);
        }
        return false;
    }

    const isParceladoBoletoDinheiro = () => {
        if (pedido.tipoPagamento) {
            return (pedido.tipoPagamento.indexOf("Boleto") !== -1 || pedido.tipoPagamento.indexOf("Dinheiro") !== -1);
        }
        return false;
    }

    const isParceladoCartao = () => {
        if (pedido.tipoPagamento) {
            return (pedido.tipoPagamento.indexOf("Parcelado") !== -1);
        }
        return false;
    }

    const setCampanhaVencimento = (codigo, checked) => {
        clearErrors('vencimentos');
        const _pedido = { ...pedido };
        if (_pedido.campanhasPagamento.includes(codigo)) {
            const index = _pedido.campanhasPagamento.indexOf(codigo);
            _pedido.campanhasPagamento.splice(index, 1);
        } else {
            _pedido.campanhasPagamento.push(codigo);
        }
        setValue('numeroParcelas', _pedido.campanhasPagamento.length);
        _pedido.numeroParcelas = _pedido.campanhasPagamento.length;
        setPedido(_pedido);
    }

    const setSemMinimo = () => {
        const _pedido = {...pedido};
        _pedido.semMinimo = !pedido.semMinimo
        setPedido(_pedido)
    }

    const setDescontoProdutos = value => {
        const _itemPedidos = [...itemPedidos];
        for (let x = 0; x < _itemPedidos.length; x++) {
            const item = _itemPedidos[x];
            item.desconto = currencyToFloat(value);
            const campo = 'desconto' + x;
            setValue(campo, value);
            document.querySelector("#desconto" + x).classList.add('hasText');
        }
        resetItemPedidos();
    }

    const parcelasIsReadonly = () => {
        return !isParceladoCartao();
    }

    const changeDataVencimento = (value, index) => {
        const _datasVencimento = [...datasVencimento];
        _datasVencimento[index].data = value;

        const _pedido = { ...pedido };
        const datasValidas = _datasVencimento.filter(obj => (obj.data !== '' && isDate(obj.data)));
        setValue('numeroParcelas', datasValidas.length);
        _pedido.numeroParcelas = datasValidas.length;

        setPedido(_pedido);
        setDatasVencimento(_datasVencimento);
    }

    return (
        <>
            {!loading &&
                <div className="form pedidos">
                    <form onSubmit={handleSubmit(onSubmit)} className="formModule branco pedidosForm">

                        {params.id &&
                            <div className="acoes">
                                {!props.compra && getSituacao(pedido) === 'Pendente' && <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> Processar</button>}
                                <button type="button" className="cancelar" onClick={() => history.push('/painel/' + rota)}><FontAwesomeIcon icon={faBan} /> Voltar</button>
                            </div>
                        }
                        <div className="break"></div>

                        <div className="field">
                            <input className={'hasText'} defaultValue={pedido.sequencia} type="text" readOnly />
                            <label>Nº</label>
                        </div>
                        <div className="field">
                            <input className={'hasText'} defaultValue={getSituacao(pedido)} type="text" readOnly />
                            <label>Situação</label>
                        </div>
                        <div className="field">
                            <input className={'hasText'} defaultValue={datetime2Front(pedido.createAt)} type="text" readOnly />
                            <label htmlFor="createAt">Data</label>
                        </div>
                        {addBreak()}

                        <div className="field">
                            <input className={'hasText'} defaultValue={getCatalogo(pedido.catalogo).nome} type="text" readOnly />
                            <label htmlFor="catalogo">Catálogo</label>
                        </div>

                        <div className="field">
                            <input className={'hasText'} defaultValue={getUsuario(pedido.usuario._id).nome} type="text" readOnly />
                            <label htmlFor="usuario">Revendedora</label>
                        </div>
                        <div className="field">
                            <input className={'hasText'} defaultValue={getUsuario(pedido.criadoPor).nome} type="text" readOnly />
                            <label htmlFor="usuario">Criado por</label>
                        </div>





                        <div className="break"></div>
                        <h3 className="tituloEtapa mt20">Itens</h3>
                        <div className="break"></div>
                        {params.id && getSituacao(pedido) === 'Pendente' && renderFormItensPedidosVenda()}

                        {addBreak()}
                        {params.id &&
                            <>
                                <div className={errors.desconto ? "field error" : "field"}>
                                    <input className={'hasText'}
                                        name="desconto" id="desconto"
                                        defaultValue={formatCurrency(pedido.desconto)}
                                        onChange={(e) => {
                                            changeValueMoney(e.target.value, { index: '', campo: 'desconto' });
                                        }}
                                        onKeyUp={(e) => hasText(e)} type="text"
                                        onBlur={(e) => setDescontoProdutos(e.target.value)}
                                        maxLength={5}
                                        ref={register()}
                                    />
                                    <label htmlFor="desconto">Desconto %</label>
                                </div>
                                <div className={errors.tipoPagamento ? "field error" : "field"}>
                                    <select name="tipoPagamento" className="hasText" ref={register({ required: true })}
                                        id="tipoPagamento" value={pedido.tipoPagamento || ""} onChange={(e) => changePagamento(e)}>
                                        {optionTiposPagamento()}
                                    </select>
                                    <label htmlFor="tipoPagamento">Pagamento</label>
                                </div>
                                <div className={errors.valorFrete ? "field error" : "field"}>
                                    <input
                                        className={'hasText'}
                                        name="valorFrete"
                                        id="valorFrete"
                                        defaultValue={formatCurrency(pedido.valorFrete)}
                                        onChange={(e) => {
                                            changeValueMoney(e.target.value, { index: '', campo: 'valorFrete' });
                                        }}
                                        type="text"
                                        ref={register()}
                                    />
                                    <label htmlFor="valorFrete">Valor Frete (cobrado na 1ª parcela)</label>
                                </div>

                                {isParcelado() && (
                                    <>
                                        {addBreak()}
                                        <div className={errors.tarifaParcela ? "field error" : "field"}>
                                            <input className={'hasText'}
                                                name="tarifaParcela" id="tarifaParcela"
                                                defaultValue={formatCurrency(pedido.tarifaParcela)}
                                                onChange={(e) => {
                                                    changeValueMoney(e.target.value, { index: '', campo: 'tarifaParcela' });
                                                    getTotalValorLiquidoParcelas();
                                                }}
                                                onKeyUp={(e) => hasText(e)} type="text"
                                                ref={register()}
                                            />
                                            <label htmlFor="tarifaParcela">Tarifa por parcela</label>
                                        </div>
                                        <div className={errors.numeroParcelas ? "field error" : "field"}>
                                            <input className={pedido.numeroParcelas ? 'hasText' : ''} name="numeroParcelas" id="numeroParcelas"
                                                defaultValue={pedido.numeroParcelas} onKeyUp={(e) => hasText(e)} type="text"
                                                onChange={() => {
                                                    getTotalValorLiquidoParcelas();
                                                }}
                                                ref={register({ validate: { isNumeric: value => !isNaN(value) } })}
                                                readOnly={parcelasIsReadonly()}
                                            />
                                            <label htmlFor="numeroParcelas">Parcelas</label>
                                        </div>
                                        <div className={"field"}>
                                            <input className={'hasText'} name="valorParcela" id="valorParcela"
                                                defaultValue={getTotalValorLiquidoParcelas()} onKeyUp={(e) => hasText(e)} type="text"
                                                ref={register()}
                                                readOnly={true}
                                            />
                                            <label htmlFor="numeroParcelas">Valor por parcela</label>
                                        </div>
                                        {isParceladoCampanha() &&
                                            <>
                                                {addBreak()}
                                                <h3 className="tituloEtapa mt20">Escolha as campanhas</h3>
                                                {/* <pre>{JSON.stringify(campanhas,null,2)}</pre> */}
                                                {addBreak()}
                                                
                                                {campanhas.map((campanha, index) => {
                                                    return <CheckBox key={index} label={campanha.codigo} value={campanha.codigo} callback={setCampanhaVencimento} checked={pedido.campanhasPagamento.includes(campanha.codigo)} />
                                                })}
                                                {addBreak()}
                                                <h3 className="tituloEtapa mt20">Detalhes do processamento</h3>
                                                {addBreak()}
                                                <CheckBox label={'Sem mínimo'} callback={setSemMinimo} />
                                        
                                            </>
                                        }
                                        {isParceladoBoletoDinheiro() &&
                                            <>
                                                {addBreak()}
                                                <h3 className="tituloEtapa mt20">Escolha as datas de vencimento</h3>
                                                {addBreak()}
                                                {datasVencimento.map((obj, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div className={errors['dataVencimento' + index] ? "field error" : "field"}>
                                                                <input
                                                                    name={`dataVencimento${index}`}
                                                                    id={`dataVencimento${index}`}
                                                                    maxLength={10}
                                                                    className={"hasText"}
                                                                    onKeyUp={(e) => { maskDate(e); }}
                                                                    type="text"
                                                                    defaultValue={obj.data}
                                                                    onBlur={(event) => {
                                                                        clearErrors('vencimentos');
                                                                        changeDataVencimento(event.target.value, index);
                                                                    }}
                                                                    ref={register({ validate: { isDate: value => isDate(value) } })}
                                                                />
                                                                <label htmlFor={`dataVencimento${index}`}>Data de Vencimento {index + 1}</label>
                                                            </div>
                                                            {index === 2 && addBreak()}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </>
                                        }
                                    </>
                                )}
                                {addBreak()}
                                <h3 className="tituloEtapa mt20">Outras informações</h3>
                                {addBreak()}
                                <div className={"field"}>
                                    <input className={'hasText'} name="obs" id="obs"
                                        defaultValue={''} onKeyUp={(e) => hasText(e)} type="text"
                                        ref={register()}
                                    />
                                    <label htmlFor="obs">Observações</label>
                                </div>
                            </>
                        }


                        <div className="break mt20"></div>
                        {params.id &&
                            <div className="acoes">
                                {!props.compra && getSituacao(pedido) === 'Pendente' && <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> Processar</button>}
                                <button type="button" className="cancelar" onClick={() => history.push('/painel/' + rota)}><FontAwesomeIcon icon={faBan} /> Voltar</button>
                            </div>
                        }
                    </form>
                    {errors && Object.keys(errors).length > 0 &&
                        <div className="erros">
                            <div><FontAwesomeIcon icon={faTimes} /> Existem erros no formulário</div>
                        </div>
                    }
                </div>
            }
            {loading && "Carregando..."}
        </>
    )
}

export default PedidosFormProcess;